import { FormControl, IInputProps, Input, Stack, Text } from 'native-base'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface PhoneInputProps {
  label?: string
  value?: string
  inputLeftElement: JSX.Element
  inputRightElement?: JSX.Element
  required?: boolean
  errorMessage?: string
  helperText?: string
}

export const PhoneInput: React.FC<PhoneInputProps & IInputProps> = ({
  errorMessage,
  label,
  helperText,
  required,
  inputLeftElement,
  inputRightElement,
  ...rest
}) => {
  const { t } = useTranslation()

  return (
    <FormControl isRequired={required} isInvalid={!!errorMessage}>
      <Stack>
        <FormControl.Label>
          <Text color={'gray.600'} fontWeight={'bold'}>
            {label || t('inputs.phone.label')}
          </Text>
        </FormControl.Label>
        <Input
          ref={rest.ref}
          type="text"
          keyboardType="phone-pad"
          testID="phone-input"
          InputLeftElement={inputLeftElement}
          InputRightElement={inputRightElement}
          {...rest}
        />
      </Stack>
      {errorMessage && <FormControl.ErrorMessage>{errorMessage}</FormControl.ErrorMessage>}
      {helperText && <FormControl.HelperText>{helperText}</FormControl.HelperText>}
    </FormControl>
  )
}

export default PhoneInput
